import { useCallback } from 'react';

import {
  VideoPlatformCoercionStrategy,
  useVideoPlatformCoercionStratCallback,
} from './useVideoPlatformCoercionStratCallback';

/**
 * Determines whether a waiting visitor can be admitted without disruption.
 */
export function useVerifyClientCompatibilityCallback() {
  const getVideoPlatformCoercionStrategy = useVideoPlatformCoercionStratCallback();

  return useCallback(
    (visitorId: string) => !(getVideoPlatformCoercionStrategy(visitorId) === VideoPlatformCoercionStrategy.Manual),
    [getVideoPlatformCoercionStrategy],
  );
}
